import React from 'react';
import SeniorCyberAssociation2025  from 'views/SeniorCyberAssociation2025';

const ClassAssembly11CPage = () => {
    return <SeniorCyberAssociation2025/>;
  };
  
  export default ClassAssembly11CPage;

  